/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Trunk_Not_Vertical16Inputs */

const en_us2_body_assessment_error_trunk_not_vertical16 = /** @type {(inputs: Body_Assessment_Error_Trunk_Not_Vertical16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trunk came out tilted. Stand up straight, shoulders, hips and ankles in a line, and keep the phone upright, not rotated to one side.`)
};

const pt_br2_body_assessment_error_trunk_not_vertical16 = /** @type {(inputs: Body_Assessment_Error_Trunk_Not_Vertical16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tronco saiu inclinado na foto. Fique em pé e reto, com ombros, quadril e tornozelos alinhados, e deixe o celular em pé, sem girar para o lado.`)
};

const es_419_body_assessment_error_trunk_not_vertical16 = /** @type {(inputs: Body_Assessment_Error_Trunk_Not_Vertical16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu tronco salió inclinado. Ponte de pie con el cuerpo recto, hombros, cadera y tobillos alineados, y mantén el teléfono en vertical, sin girarlo hacia un lado.`)
};

const pt_pt2_body_assessment_error_trunk_not_vertical16 = /** @type {(inputs: Body_Assessment_Error_Trunk_Not_Vertical16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tronco saiu inclinado na foto. Fica de pé e direito, com ombros, anca e tornozelos alinhados, e deixa o telemóvel na vertical, sem o rodar para o lado.`)
};

const fr_fr2_body_assessment_error_trunk_not_vertical16 = /** @type {(inputs: Body_Assessment_Error_Trunk_Not_Vertical16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton tronc est sorti penché. Tiens-toi droit, épaules, hanches et chevilles alignées, et garde le téléphone vertical, sans le tourner sur le côté.`)
};

const de_de2_body_assessment_error_trunk_not_vertical16 = /** @type {(inputs: Body_Assessment_Error_Trunk_Not_Vertical16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Rumpf war geneigt. Steh aufrecht, Schultern, Hüfte und Knöchel in einer Linie, und halte das Handy aufrecht, nicht zur Seite gedreht.`)
};

const it_it2_body_assessment_error_trunk_not_vertical16 = /** @type {(inputs: Body_Assessment_Error_Trunk_Not_Vertical16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tronco è risultato inclinato. Stai dritto, con spalle, fianchi e caviglie allineati, e tieni il telefono in verticale, non ruotato di lato.`)
};

/**
* | output |
* | --- |
* | "Your trunk came out tilted. Stand up straight, shoulders, hips and ankles in a line, and keep the phone upright, not rotated to one side." |
*
* @param {Body_Assessment_Error_Trunk_Not_Vertical16Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_trunk_not_vertical16 = /** @type {((inputs?: Body_Assessment_Error_Trunk_Not_Vertical16Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Trunk_Not_Vertical16Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_trunk_not_vertical16(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_trunk_not_vertical16(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_trunk_not_vertical16(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_trunk_not_vertical16(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_trunk_not_vertical16(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_trunk_not_vertical16(inputs)
	return en_us2_body_assessment_error_trunk_not_vertical16(inputs)
});
export { body_assessment_error_trunk_not_vertical16 as "body-assessment.error.TRUNK_NOT_VERTICAL" }